import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyCOf9jcQRYTYL53_fPY_FV6FGlfJnsN4_U",
  authDomain: "homecookt-7d9f9.firebaseapp.com",
  projectId: "homecookt-7d9f9",
  storageBucket: "homecookt-7d9f9.firebasestorage.app",
  messagingSenderId: "830893025393",
  appId: "1:830893025393:web:1215e75a8dc953ffa313d0",
  measurementId: "G-JVTERKMFF6"
};

const app = initializeApp(firebaseConfig);

// Firebase Cloud Messaging
export const messaging = getMessaging(app);

// Analytics (optional)
isSupported().then((supported) => {
  if (supported) {
    getAnalytics(app);
  }
});

export default app;